import styled from 'styled-components';

export const FormWrapper = styled.form`
  display: grid;
  grid-gap: 16px;
`;
